/* tslint:disable */
/* eslint-disable */
/**
 * User service API
 * Service for user management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WitnessDto
 */
export interface WitnessDto {
    /**
     * Witness name
     * @type {string}
     * @memberof WitnessDto
     */
    name?: string;
    /**
     * Witness prefix
     * @type {string}
     * @memberof WitnessDto
     */
    prefix?: string;
    /**
     * Witness base url
     * @type {string}
     * @memberof WitnessDto
     */
    witnessUrl?: string;
    /**
     * Witness OOBI url
     * @type {string}
     * @memberof WitnessDto
     */
    url?: string;
}

/**
 * Check if a given object implements the WitnessDto interface.
 */
export function instanceOfWitnessDto(value: object): boolean {
    return true;
}

export function WitnessDtoFromJSON(json: any): WitnessDto {
    return WitnessDtoFromJSONTyped(json, false);
}

export function WitnessDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WitnessDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'prefix': json['prefix'] == null ? undefined : json['prefix'],
        'witnessUrl': json['witnessUrl'] == null ? undefined : json['witnessUrl'],
        'url': json['url'] == null ? undefined : json['url'],
    };
}

export function WitnessDtoToJSON(value?: WitnessDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'prefix': value['prefix'],
        'witnessUrl': value['witnessUrl'],
        'url': value['url'],
    };
}

